'use client';

import { z } from 'zod';

import { browserApiRequest } from '@/shared/api';

import {
  AddressListSchema,
  ProfileSchema,
  SendOtpResultSchema,
  ViewerSchema,
  type AddAddressCommand,
  type UpdateProfileCommand,
} from '../model/customer';

const json = (body: unknown) => JSON.stringify(body);

export function requestOtp(phone: string) {
  return browserApiRequest('/api/auth/otp', SendOtpResultSchema, {
    method: 'POST',
    body: json({ phone, consent: true }),
  });
}

export function verifyOtp(phone: string, code: string) {
  return browserApiRequest('/api/auth/otp/verify', ViewerSchema, {
    method: 'POST',
    body: json({ phone, code }),
  });
}

export function loginWithProvider(provider: 't-id' | 'yandex-id') {
  return browserApiRequest('/api/auth/oauth', ViewerSchema, {
    method: 'POST',
    body: json({ provider, consent: true }),
  });
}

export function logout() {
  return browserApiRequest('/api/auth/logout', ViewerSchema, { method: 'POST' });
}

export function updateProfile(command: UpdateProfileCommand) {
  return browserApiRequest('/api/account/profile', ProfileSchema, {
    method: 'PATCH',
    body: json(command),
  });
}

export function addAddress(command: AddAddressCommand) {
  return browserApiRequest('/api/account/addresses', AddressListSchema, {
    method: 'POST',
    body: json(command),
  });
}

export function makeDefaultAddress(id: string) {
  return browserApiRequest(`/api/account/addresses/${encodeURIComponent(id)}`, AddressListSchema, {
    method: 'PATCH',
    body: json({ isDefault: true }),
  });
}

export function subscribeNewsletter(email: string) {
  return browserApiRequest('/api/newsletter', z.object({ status: z.literal('subscribed') }), {
    method: 'POST',
    body: json({ email, consent: true }),
  });
}
